/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pen': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.854 2.146a.5.5 0 00-.707 0L11.23 4.063 6.443 5.659a2.5 2.5 0 00-1.66 1.881L3.01 16.402a.5.5 0 00.588.588l8.862-1.772a2.5 2.5 0 001.881-1.661l1.596-4.787 1.917-1.916a.5.5 0 000-.708l-4-4zm1.074 6.49l-3.563-3.564-4.606 1.535a1.5 1.5 0 00-.996 1.13l-1.449 7.242 3.963-3.963a2 2 0 11.707.707L5.02 15.686l7.243-1.449a1.5 1.5 0 001.129-.996l1.535-4.606zm.572-.843L16.793 6.5 13.5 3.207 12.207 4.5 15.5 7.793zm-4.793 1.5a1 1 0 10-1.414 1.414 1 1 0 001.414-1.414z" _fill="#1F222C"/>'
  }
})
